var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-form text-white relative",attrs:{"id":"form"}},[_c('div',{staticClass:"centered-content-container  mx-auto block-wrap"},[_c('div',{ref:"bitrix",staticClass:"bitrix"})])])}
var staticRenderFns = []

export { render, staticRenderFns }